var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXsmallLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.288 2.568L4.726 7.912A.7.7 0 005.308 9H6.7a.3.3 0 01.3.3v3.26c0 .702.921.967 1.294.37l3.037-4.859A.7.7 0 0010.737 7H9.346a.3.3 0 01-.297-.342l.515-3.603c.105-.738-.862-1.107-1.276-.487z",
    fill: "#fff"
  })));
}
export default SvgXsmallLightning;